

export function executeCallback(callback, ...params) {
  if (callback && typeof callback === 'function') {
    return callback(...params);
  }
  return null;
}
